<template>
	<section
		:class="['content', { 'sticky-learning-content': isLearningVideo }]"
	>
		<!-- <app-header/> -->
		<app-messages />

		<router-view :key="$route.fullPath" v-slot="{ Component }">
			<keep-alive>
				<transition name="page-transition" mode="in-out">
					<component :is="Component" class="view" />
				</transition>
			</keep-alive>
		</router-view>
	</section>
</template>

<script>
// import AppHeader from '@/components/AppHeader'
import AppMessages from '@/components/AppMessages';
export default {
	components: {
		// AppHeader,
		AppMessages,
	},
	computed: {
		isLearningVideo() {
			return this.$route.name === 'eLearningVideos';
		},
	},
};
</script>
